export enum DeliveryModes {
  PR = 'PR', //presencial
  SP = 'SP', //semi-presencial,
  OL = 'OL', //online
  OA = 'OA', //online - autoatendido
}

export enum StructureTypes {
  FREE = 'Libre',
  FIXED = 'Fija',
  SEMIFIXED = 'Semi Fija',
}
